import { AnimationsAndTransitionsConfiguration } from "./animations-and-transitions-configuration";
import { AnswersConfiguration } from "./answers-configuration";
import { BrandingConfiguration } from "./branding-configuration";
import { ColorsConfiguration } from "./colors-configuration";
import { CustomCSSConfiguration } from "./custom-css-configuration";
import { FontsConfiguration } from "./fonts-configuration";
import { PdfConfiguration } from "./pdf-configuration";
import { PriceConfiguration } from "./price-configuration";
import { ProductButtonConfiguration } from "./product-button-configuration";
import { ProductRatingConfiguration } from "./product-rating-configuration";
import { QuestionConfiguration } from "./question-configuration";
import { RecommendationConfiguration } from "./recommendation-configuration";
import { StandardTextsConfiguration } from "./standard-texts-configuration";
import { TopProductConfiguration } from "./top-product-configuration";
import { SearchbarConfiguration } from "./searchbar-configuration";

/**
 * @additionalProperties false
 */
export class ComponentsConfiguration {
    public questionConfiguration?: QuestionConfiguration = new QuestionConfiguration();
    public colors?: ColorsConfiguration = new ColorsConfiguration();
    public fonts?: FontsConfiguration = new FontsConfiguration();
    public answersConfiguration?: AnswersConfiguration = new AnswersConfiguration();
    public standardTexts?: StandardTextsConfiguration = new StandardTextsConfiguration();
    public topProductSettings: TopProductConfiguration = new TopProductConfiguration();
    public recommendationSettings: RecommendationConfiguration = new RecommendationConfiguration();
    public productRating?: ProductRatingConfiguration = new ProductRatingConfiguration();
    public price?: PriceConfiguration = new PriceConfiguration();
    public branding?: BrandingConfiguration = new BrandingConfiguration();
    public customCSSConfiguration?: CustomCSSConfiguration = new CustomCSSConfiguration();
    public productButtonConfiguration?: ProductButtonConfiguration = new ProductButtonConfiguration();
    public pdfConfiguration?: PdfConfiguration = new PdfConfiguration();
    public animationsAndTransitionsConfiguration?: AnimationsAndTransitionsConfiguration = new AnimationsAndTransitionsConfiguration();
    public searchbarConfiguration?: SearchbarConfiguration = new SearchbarConfiguration();
}
